export const STALE_TIMES = {
  ORGANIZATION_DATA: 10 * 60 * 1000, // 10 minutes
  USER_DATA: 5 * 60 * 1000, // 5 minutes
  LABOUR_ITEMS: 2 * 60 * 1000, // 2 minutes
  SITE_DATA: 5 * 60 * 1000, // 5 minutes
  INVITATION: 30 * 1000, // 30 seconds
} as const;

export const CACHE_TIMES = {
  DEFAULT: 15 * 60 * 1000, // 15 minutes
  LONG: 30 * 60 * 1000, // 30 minutes
} as const;
